import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styled from 'styled-components';

const StyledButton = styled.button`
  background: transparent;
  border: none;
  color: rgb(95, 100, 121);
  padding: 15px;
  transition: all .1s ease-out;

  &:hover {
    color: rgb(252, 177, 46) !important;
  }
`

export const IconButton = ({ icon, onClick }) => {
  return (
    <StyledButton onClick={onClick}>
      <FontAwesomeIcon icon={['fal', icon]} />
    </StyledButton>
  )
}